export default __webpack_public_path__ + "static/media/handphone_2.8e7a305e.png";